import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VideoCardBenchmarkItem } from '@models/domain/video.card.benchmark.item';
import { AddVideoCardBenchmarkRequest } from '@models/ss-api/requests/add.video.card.benchmark.request';
import { UpdateVideoCardBenchmarkRequest } from '@models/ss-api/requests/update.video.card.benchmark.request';

export interface IUpdateGPUBenchmarkTemplate {
    Title: string;
    GPUBenchmark?: VideoCardBenchmarkItem;
}

@Component({
    selector: 'update-gpubenchmark-dialog',
    styleUrls: ['./update.gpubenchmark.dialog.scss'],
    templateUrl: './update.gpubenchmark.dialog.html'
})

export class UpdateGPUBenchmarkDialog extends DialogComponent<IUpdateGPUBenchmarkTemplate, boolean> implements IUpdateGPUBenchmarkTemplate, OnInit {
    IsBusy: boolean;
    Title: string;
    GPUBenchmark: VideoCardBenchmarkItem;

    GPUBenchmarkForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.GPUBenchmark) {
            this.GPUBenchmark = new VideoCardBenchmarkItem();
        } else {

        }

        this.GPUBenchmarkForm = new FormGroup({
            'VideoCardName': new FormControl(this.GPUBenchmark.VideoCardName, [Validators.required]),
            'BenchmarkScore': new FormControl(this.GPUBenchmark.BenchmarkScore, [Validators.required, Validators.maxLength(7), Validators.minLength(1), Validators.pattern('^-?[0-9 \]+$')])
        })
    }

    confirm() {
        if (!this.GPUBenchmarkForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.GPUBenchmarkForm.controls;

        if (!this.GPUBenchmark.VideoCardBenchmarkID) {
            let request: AddVideoCardBenchmarkRequest = {
                VideoCardName : controls['VideoCardName'].value,
                BenchmarkScore: controls['BenchmarkScore'].value
            }

            let disposable = this.api.AddVideoCardBenchmark(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                disposable.unsubscribe();
            })
        } else {
            let request: UpdateVideoCardBenchmarkRequest = {
                VideoCardBenchmarkID: this.GPUBenchmark.VideoCardBenchmarkID,
                NewBenchmarkScore: controls['BenchmarkScore'].value
            }

            let disposable = this.api.UpdateVideoCardBenchmark(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                else{
                    console.log(response);
                }
                disposable.unsubscribe();
            })
        }
    }

}
